(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ark-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
  function initStickyAtc(barEl) {
    var selector = barEl.dataset.observe;
    if (!selector) return;

    var target = document.querySelector(selector);
    if (!target) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            barEl.classList.remove('is-visible');
            barEl.setAttribute('aria-hidden', 'true');
          } else {
            barEl.classList.add('is-visible');
            barEl.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(target);
  }

  // Support multiple sticky bars on one page (edge case)
  document.querySelectorAll('.ark-sticky-atc').forEach(function (el) {
    initStickyAtc(el);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
